import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Card, Typography, Grid, Chip, Button, Stack, Box, Divider, Tooltip, Snackbar, Alert
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import BarChartIcon from '@mui/icons-material/BarChart';
import OpportunityModal from '../jobOpportunityModel';
import {
  IoTdevelopercourses,
  IoTDataScientistcourses,
  IndustrialiotCourses,
} from "../../../iotLearningPath/Courses/coursesdata";

import {
  IoTdeveloperProjects,
  IoTDataScientistProjects,
  IndustrialProjects,
} from "../../../iotLearningPath/Courses/projectsData";
import getLearningPathData from "../../../iotLearningPath/dashboard/api";
import { LearnersHiretech, Organizationapplied, Organizationapplyjobs } from "../../../../../../helper/base_url";

const FullTimeOpportunities = () => {
  const [selectedOption] = useState(localStorage.getItem("selectedLearningPath") || "");
  const [responseData, setResponseData] = useState({ HOE: 0 });
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [stickyMessageIndex, setStickyMessageIndex] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [appliedHiringIds, setAppliedHiringIds] = useState([]);

  useEffect(() => {
    const fetchOpportunities = async () => {
      try {
        const res = await axios.get(`${LearnersHiretech}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });

        const domainList = [
          'datascience', 'dataScience', 'DataScience', 'DATASCIENCE', 'Data Science', 'AI/ML', 'Other',
          'Artificial Intelligence', 'Machine Learning', 'Deep Learning', 'Big Data', 'Data Analytics', 'Data Engineering'
        ];

        const fullTimeData = res.data.data
          .map(company => ({
            ...company,
            hirings: company.hirings
              //.filter(hiring => hiring.opportunityOverview.opportunityType === 'Full-time Job')
               .filter(hiring =>
                hiring.opportunityOverview.opportunityType === 'Full-time Job' &&
                hiring.overallStatus === 'Accepted' &&
                Array.isArray(hiring.roleDetails.domain) &&
                hiring.roleDetails.domain.some(domain =>
                domainList.includes(domain)
                )
              )

              .map(hiring => {
                const deadline = new Date(hiring.compensationAndDates.applicationDeadline);
                const now = new Date();
                const status = deadline >= now ? 'Open' : 'Closed';
                return { ...hiring, status, deadline };
              }),
          }))
          .filter(company => company.hirings.length > 0);

        setOpportunities(fullTimeData);
      } catch (error) {
        //console.error('Error fetching opportunities:', error);
      } finally {
        setLoading(false);
      }
    };

    const fetchAppliedJobs = async () => {
      try {
        const res = await axios.get(`${Organizationapplied}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
  
        const ids = res.data.ListOfhiringId || [];
        const hiringIds = ids.map(id => id._id || id);
        setAppliedHiringIds(hiringIds);
      } catch (err) {
        //console.error("Failed to fetch applied jobs:", err);
      }
    };

    fetchOpportunities();
    fetchAppliedJobs();
  }, []);
  useEffect(() => {
    if (selectedOption) {
      const fetchData = async () => {
        try {
          switch (selectedOption) {
            case "IoT Developer / Engineer":
              getLearningPathData(
                selectedOption,
                IoTdevelopercourses[0]?.courses || [],
                IoTdeveloperProjects[0]?.projects || [],
                setResponseData
              );
              break;
            case "IoT Data Scientist":
              getLearningPathData(
                selectedOption,
                IoTDataScientistcourses[0]?.courses || [],
                IoTDataScientistProjects[0]?.projects || [],
                setResponseData
              );
              break;
            case "Industrial IoT & Industry 4.0":
              getLearningPathData(
                selectedOption,
                IndustrialiotCourses[0]?.courses || [],
                IndustrialProjects[0]?.projects || [],
                setResponseData
              );
              break;
            default:
              console.log(`Invalid learning path in localStorage: "${selectedOption}"`);
          }
        } catch (error) {
          console.error("Error fetching learning path data:", error);
        }
      };

      fetchData();
    }
  }, [selectedOption]);
//   const handleApplyClick = (id) => {
//   if (responseData.HOE < 75) {
//     setStickyMessageIndex(id);
//     setTimeout(() => setStickyMessageIndex(null), 5000); // auto-hide after 5s
//   } else {
//     navigate('/learners/dashboard/userprofile');
//   }
// };
const handleApplyClick = async (companyId, hiringId) => {
  if (responseData.HOE < 75) {
    setStickyMessageIndex(hiringId);
    setTimeout(() => setStickyMessageIndex(null), 5000);
    return;
  }

  try {
    const res = await axios.post(`${Organizationapplyjobs}`, {
      companyId,
      hiringId
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });

    setSnackbar({
      open: true,
      message: res.data.message || "Application submitted successfully!",
      severity: 'success'
    });

    // Mark as applied
    setAppliedHiringIds(prev => [...prev, hiringId]);
  } catch (error) {
    //console.error("Application error:", error.response?.data || error.message);
    setSnackbar({
      open: true,
      message: error.response?.data?.error || "Failed to apply",
      severity: 'error'
    });
  }
};
  const handleOpenModal = (hiring) => {
    setSelectedOpportunity(hiring);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  if (loading) return <Typography align="center" mt={4}>Loading full-time opportunities...</Typography>;
  if (opportunities.length === 0) return <Typography align="center" mt={4}>No full-time jobs available.</Typography>;

  return (
    <>
      <Grid container spacing={4} padding="10px 20px">
        {opportunities.map(company =>
          company.hirings.map((hiring, index) => (
            <Grid item xs={12} md={6} key={`${company._id}-${index}`}>
              <Card
                sx={{
                  borderRadius: "10px",
                  p: 2,
                  boxShadow: 5,
                  '&:hover': { boxShadow: 8, transform: 'translateY(-4px)' },
                  transition: '0.3s',
                  backgroundColor: '#fafafa',
                }}
              >
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Box>
                    <Typography variant="h6" fontWeight="600" color="#052659" fontSize="1rem" paddingRight="20px">
                      {hiring.opportunityOverview.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                      {company.companyName} • {hiring.opportunityOverview.location}
                    </Typography>
                  </Box>
                  {/* <Avatar
                    src={company.logoUrl || '/default-logo.png'}
                    alt="Company Logo"
                    variant="rounded"
                    sx={{ width : 60, height : 60 }}
                  /> */}
                </Box>

                <Divider sx={{ my: 2 }} />

                <Stack direction="row" spacing={4} mb={2}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <AccessTimeIcon color="action" fontSize="small" />
                    <Box>
                      <Typography variant="caption" color="text.secondary">Duration</Typography>
                      <Typography variant="body2">{hiring.opportunityOverview.duration || '-'}</Typography>
                    </Box>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1}>
                    <MonetizationOnIcon color="action" fontSize="small" />
                    <Box>
                      <Typography variant="caption" color="text.secondary">Compensation</Typography>
                      <Typography variant="body2">
                        {hiring.compensationAndDates.stipendOrSalary
                          ? `₹ ${hiring.compensationAndDates.stipendOrSalary}`
                          : 'Unpaid'}
                      </Typography>
                    </Box>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1}>
                    <BarChartIcon color="action" fontSize="small" />
                    <Box>
                      <Typography variant="caption" color="text.secondary">Level</Typography>
                      <Typography variant="body2">{hiring.opportunityOverview.experience}</Typography>
                    </Box>
                  </Box>
                </Stack>

                <Stack direction="row" spacing={1} flexWrap="wrap" mb={2}>
                  {hiring.roleDetails.skills.slice(0, 4).map((skill, i) => (
                    <Chip key={i} label={skill} size="small" sx={{ backgroundColor: '#e3f2fd', color: '#0d47a1' }} />
                  ))}
                </Stack>

                <Stack direction="row" justifyContent="space-between" alignItems="center" mt={2}>
                  <Tooltip title={`Application Deadline: ${hiring.deadline.toLocaleDateString()}`}>
                    <Chip
                      label={hiring.status}
                      color={hiring.status === 'Open' ? 'success' : 'error'}
                      size="small"
                      variant="outlined"
                    />
                  </Tooltip>
                  <Stack direction="row" spacing={1}>
                    <Button variant="outlined" size="small" onClick={() => handleOpenModal(hiring)}>
                      View Details
                    </Button>
                    {/* <Button variant="contained" size="small" endIcon={<ArrowForwardIcon />}>
                      Apply
                    </Button> */}
                     {/* <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleApplyClick(hiring._id)}
                      sx={{
                        backgroundColor: "#6A6CFF",
                        borderRadius: "16px",
                        textTransform: "none",
                        fontSize: "0.7rem",
                        padding: "4px 12px",
                      }}
                      endIcon={<ArrowForwardIcon fontSize="small" />}
                    >
                    Apply
                  </Button> */}
                  {appliedHiringIds.includes(hiring._id) ? (
                    <Button
                      variant="contained"
                      size="small"
                      disabled
                      sx={{
                        backgroundColor: "#ccc",
                        borderRadius: "16px",
                        textTransform: "none",
                        fontSize: "0.7rem",
                        padding: "4px 12px",
                      }}
                    >
                      Applied
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleApplyClick(company._id, hiring._id)}
                      disabled={hiring.status !== 'Open'}
                      sx={{
                        backgroundColor: "#6A6CFF",
                        borderRadius: "16px",
                        textTransform: "none",
                        fontSize: "0.7rem",
                        padding: "4px 12px",
                      }}
                      endIcon={<ArrowForwardIcon fontSize="small" />}
                    >
                      Apply
                    </Button>
                  )}
                  </Stack>
                </Stack>
              </Card>
               {stickyMessageIndex === hiring._id && (
                <Box
                  sx={{
                    position: 'fixed',
                    top : 80,
                    left : '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: '#fff1f2',
                    color: '#b91c1c',
                    padding: '10px',
                    fontSize: '12px',
                    fontWeight: 600,
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
                    zIndex: 1000,
                    display: 'flex',
                    alignItems: 'center',
                    gap: "10px",
                  }}
                >
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/1828/1828843.png"
                    alt="alert"
                    style={{ height : 16, width : 16 }}
                  />
                  Reach 75% HOE Score to become eligible for job opportunities. Keep going!
                </Box>
              )}
              <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
              <Alert
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                severity={snackbar.severity}
                sx={{ width : '100%' }}
              >
                {snackbar.message}
              </Alert>
            </Snackbar>
            </Grid>
          ))
        )}
      </Grid>
      <OpportunityModal
        open={openModal}
        onClose={handleCloseModal}
        opportunity={selectedOpportunity}
      />
    </>
  );
};

export default FullTimeOpportunities;

